import {
  HOME_TO_STORE_SUBMIT_DATA_INFO,
  HomeToStoreStartSubmitFormData,
  IN_STORE_SUBMIT_DATA_INFO,
  InStoreStartLoadingAgencyInfoAction,
  InStoreStartSubmitFormData,
  START_LOADING_IN_STORE_AGENCY_INFO,
} from '../InStore.types';

export const startLoadInStoreAgency = (slug: string): InStoreStartLoadingAgencyInfoAction => ({
  type: START_LOADING_IN_STORE_AGENCY_INFO,
  slug,
});

export const startSubmitInStoreFormData = (): InStoreStartSubmitFormData => ({
  type: IN_STORE_SUBMIT_DATA_INFO,
});

export const startSubmitHomeToStoreFormData = (): HomeToStoreStartSubmitFormData => ({
  type: HOME_TO_STORE_SUBMIT_DATA_INFO,
});
